export const NotesController = (
  $scope,
  $location,
  NotesApi,
  notesModal,
  userService,
  CandidateProfileApi
) => {
  $scope.sortListData = [
    {
      value: '-created',
      label: 'Date',
    },
    {
      value: 'category',
      '-created': '-created',
      label: 'Type',
    },
  ]
  $scope.noteUser = $location.search().user
  if (!$scope.noteUser && $scope.user) $scope.noteUser = $scope.user.id
  $scope.employerId = $location.search().employer
    ? Number($location.search().employer)
    : undefined
  $scope.employerName = $location.search().employer
    ? $location.search().employerName
    : undefined

  async function fetchUserNotes(userId) {
    const {data: employers} = await CandidateProfileApi.getEmployersList()
    const {data: userNotes} = await NotesApi.getAllNotes({user: [userId]})

    modalData.employers = employers
    modalData.authors = $scope.authors
    $scope.notes = userNotes.map(note =>
      Object.assign(
        {
          employer: note.employerId
            ? employers.find(employer => employer.id === note.employerId)
            : undefined,
          author: note.authorId
            ? $scope.authors.find(author => author.id === note.authorId)
            : undefined,
        },
        note
      )
    )
    $scope.allNotes = $scope.notes
    if ($scope.notes.length > 0) $scope.noNotes = false
    $scope.$apply()
  }

  async function fetchEmployerNotes(employerId) {
    const {data: allCandidate} = await CandidateProfileApi.getCandidateList()
    const {data: employerNotes} = await NotesApi.getAllNotes({
      employer: [employerId],
    })
    modalData.candidates = allCandidate
    modalData.authors = $scope.authors
    $scope.notes = employerNotes.map(note =>
      Object.assign(
        {
          candidate: note.userId
            ? allCandidate.find(candidate => candidate.id === note.userId)
            : undefined,
          author: note.authorId
            ? $scope.authors.find(author => author.id === note.authorId)
            : undefined,
        },
        note
      )
    )
    $scope.allNotes = $scope.notes
    if ($scope.notes.length > 0) $scope.noNotes = false
    $scope.$apply()
  }

  $scope.openNotesModal = async () => {
    modalData.note = await $scope.resetNote(modalData.note)
    $scope.notes = notesModal.openAddNoteModal(
      modalData,
      $scope.notes,
      $scope.noNotes
    )
    $scope.noNotes = false
  }

  $scope.editNote = (noteID, index) => {
    modalData.note = $scope.resetNote(modalData.note)
    const temporaryNote = $scope.notes.find(note => note.id === noteID)
    index = $scope.notes.indexOf(temporaryNote)
    modalData.note = Object.assign({}, temporaryNote, {
      authorId: $scope.loginUser.id,
    })
    return notesModal.openEditNoteModal($scope.notes, index, modalData)
  }

  $scope.noteHistory = async noteID => {
    const payload = {
      category: 'note',
      type: 'NOTE_UPDATE',
      target: noteID,
    }
    const {data: noteHistory} = await NotesApi.getNoteHistory(payload)
    const notes = noteHistory.map(note => {
      return {
        created: note.created,
        employer:
          note.payload.old.employerId && modalData.employers
            ? modalData.employers.find(
                employer => employer.id === note.payload.old.employerId
              )
            : undefined,
        candidate:
          note.payload.old.userId && modalData.candidates
            ? modalData.candidates.find(
                candidate => candidate.id === note.payload.old.userId
              )
            : undefined,
        author: note.payload.old.authorId
          ? modalData.authors.find(
              author => author.id === note.payload.old.authorId
            )
          : undefined,
        data: note.payload.old,
      }
    })
    return notesModal.openNoteHistoryModal(notes)
  }

  $scope.deleteNote = (noteID, index) => {
    var temporaryNote
    temporaryNote = $scope.notes.find(note => note.id === noteID)
    index = $scope.notes.indexOf(temporaryNote)
    notesModal.openDeleteNoteModal(noteID, $scope.notes, index)
  }

  const modalData = {
    noteType: ['Comment', 'Conversation', 'Interview Feedback'],
    employers: [],
    assignTo: [],
    note: $scope.Note,
    selectedFirm: [],
    isEmployerNote: false,
    isUserNote: false,
  }

  $scope.searchNotes = searchWord => {
    $scope.notes = []
    $scope.allNotes.forEach(note => {
      if (
        (note.subject &&
          note.subject.toLowerCase().includes(searchWord.toLowerCase())) ||
        (note.body &&
          note.body.toLowerCase().includes(searchWord.toLowerCase()))
      ) {
        $scope.notes.push(note)
      }
    })
  }

  $scope.clearSearchKey = () => {
    $scope.searchKeywords.value = ''
    $scope.searchNotes('')
  }

  $scope.resetNote = async note => {
    note = {
      body: undefined,
      subject: undefined,
      attendees: undefined,
      medium: undefined,
      category: undefined, // Note type
      time: new Date(),
      date: new Date(),
      authorId: $scope.loginUser.id,
      employerId: $scope.employerId,
      userId: $scope.noteUser,
    }
    return note
  }

  $scope.initializeNotesController = async () => {
    $scope.loginUser = await userService.getUser()
    const {
      data: authors,
    } = await CandidateProfileApi.getAdminAndCorporateUsers()
    $scope.authors = authors

    $scope.Note = $scope.resetNote({})

    if ($scope.noteUser) {
      modalData.isUserNote = true
      fetchUserNotes($scope.noteUser)
    }

    if ($scope.employerId) {
      modalData.isEmployerNote = true
      fetchEmployerNotes($scope.employerId)
    }

    console.debug('initializeNotesController done')
  }

  $scope.initializeNotesController()
}



// WEBPACK FOOTER //
// ./scripts/notes/notes.ctrl.js